<div class="print-header">
	<ng-content select="[pms-print-header]"></ng-content>
</div>
<div class="print-body">
	<ng-content select="[pms-print-body]"></ng-content>
</div>
<div class="print-footer">
	<ng-content select="[pms-print-footer]"></ng-content>
</div>
